import React from "react";
import { Button } from "@mui/material";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
//import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";

export function Whoops404() {
  //const { user, setUser } = useUser();

  //console.log(user);
  //console.log(setUser);
  const navigate = useNavigate();

  return (
    <div className="asset-list-root">
      <AccountMenu />
      {/* <Navigation /> */}
      Whoops 404
      <Button
        onClick={() => {
          navigate("/SignIn");
        }}
      >
        test
      </Button>
    </div>
  );
}
